import { render, staticRenderFns } from "./ProjectHeader.vue?vue&type=template&id=175479c9&scoped=true&"
import script from "./ProjectHeader.vue?vue&type=script&lang=ts&"
export * from "./ProjectHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175479c9",
  null
  
)

export default component.exports